import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Container from 'common/Container';
import { useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import {
  SHOW_LOGO_MARKETING_EN_MOVIMIENTO_URL,
  SHOW_COVER_MARKETING_EN_MOVIMIENTO_URL,
} from '../data/assets';

const Who = ({ themeMode = 'light' }) => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Container
          sx={{
            backgroundImage: themeMode === 'dark' ? 'url(/images/logos/logo_white.PNG)' : 'url(/images/logos/logo_tnonetwork_black.png)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            height: '20vh',
          }}
        />
        <Box
          component={Typography}
          fontWeight={700}
          variant={'h3'}
          gutterBottom
          align={'center'}
          color={theme.palette.primary.main}
        >
          Marketing en Movimiento: estrategia, negocios y transformación digital
        </Box>
        <Typography
          variant={'h6'}
          component={'p'}
          color={'textSecondary'}
          align={'center'}
        >
          El espacio de TNO Network donde marcas, emprendedores y profesionales del marketing encuentran tendencias, casos reales y herramientas para crecer. Tu marca se integra en conversaciones sobre economía, emprendimiento, neuroventas, talento y marketing real — con audiencia que toma decisiones de inversión.
        </Typography>
        <Typography
          variant={'h5'}
          component={'p'}
          color={theme.palette.primary.main}
          align={'center'}
          sx={{ mt: 3, mb: 2, fontStyle: 'italic' }}
        >
          ¿Qué es Marketing en Movimiento?
        </Typography>
        <Typography align="center" sx={{ mb: 1 }}>
          <Link
            href="https://tnonetwork.com/show/marketingenmovimiento"
            target="_blank"
            rel="noopener noreferrer"
            color="primary"
            underline="hover"
          >
            tnonetwork.com/show/marketingenmovimiento
          </Link>
        </Typography>
        <Typography
          variant={'body1'}
          component={'p'}
          color={'textSecondary'}
          align={'center'}
          sx={{ mt: 1 }}
        >
          Un ecosistema de contenido para quienes buscan impulsar su carrera y sus negocios en la era digital. Entrevistas con expertas, análisis de mercado, metodologías de <strong>Marketing Real</strong> y casos de éxito en Venezuela y la región. Presencia en app y web de TNO, biblioteca On-Demand y redes del ecosistema. Transmisión en vivo los <strong>martes a las 11:00 AM</strong> (horario Venezuela) por TNO Network.
        </Typography>

        <Box
          sx={{
            position: 'relative',
            width: '100%',
            maxWidth: 900,
            mx: 'auto',
            mt: 4,
            borderRadius: 2,
            overflow: 'hidden',
            boxShadow: 3,
            aspectRatio: '16 / 9',
            bgcolor: 'common.black',
          }}
        >
          <Box
            component="img"
            src={SHOW_COVER_MARKETING_EN_MOVIMIENTO_URL}
            alt="Marketing en Movimiento — TNO Network"
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              opacity: 0.85,
            }}
          />
          <Box
            component="img"
            src={SHOW_LOGO_MARKETING_EN_MOVIMIENTO_URL}
            alt="Logo Marketing en Movimiento"
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              maxWidth: { xs: '58%', sm: '42%' },
              maxHeight: '42%',
              width: 'auto',
              height: 'auto',
              objectFit: 'contain',
              pointerEvents: 'none',
              zIndex: 1,
              filter: 'drop-shadow(0 4px 14px rgba(0,0,0,0.5))',
            }}
          />
        </Box>
      </Box>

      <Box marginTop={6} marginBottom={4}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Typography
              variant={'h5'}
              fontWeight={700}
              gutterBottom
              color={theme.palette.primary.main}
            >
              LOYOLA ROSALES
            </Typography>
            <Typography
              variant={'body2'}
              color={'textSecondary'}
              sx={{ fontStyle: 'italic', mb: 2 }}
            >
              CEO de CME Marketing Solutions · Docente UCV · Consultora de negocios
            </Typography>
            <Typography variant={'body1'} color={'textSecondary'}>
              <strong>Lic. Loyola Rosales</strong> aporta visión estratégica y experiencia en mercadeo y publicidad. Su enfoque conecta teoría académica con resultados en campo: ideal para marcas que buscan credibilidad B2B y conversaciones de alto valor.
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography
              variant={'h5'}
              fontWeight={700}
              gutterBottom
              color={theme.palette.primary.main}
            >
              LUZMEY HERNÁNDEZ
            </Typography>
            <Typography
              variant={'body2'}
              color={'textSecondary'}
              sx={{ fontStyle: 'italic', mb: 2 }}
            >
              CEO de UPA B2B · Estratega de marketing · Experta en marketing digital.
            </Typography>
            <Typography variant={'body1'} color={'textSecondary'}>
              <strong>Lic. Luzmey Hernández</strong> lidera la vertiente digital y de performance del programa. Traduce tendencias, IA y funnels en acciones concretas para pymes y empresas que quieren escalar con datos y creatividad.
            </Typography>
          </Grid>
        </Grid>
        <Typography align="center" sx={{ mt: 3 }} color="textSecondary" variant="body2">
          Síguenos en Instagram:{' '}
          <Link href="https://instagram.com/marketingenmov" target="_blank" rel="noopener noreferrer" color="primary">
            @marketingenmov
          </Link>
        </Typography>
      </Box>
    </Box>
  );
};

Who.propTypes = {
  themeMode: PropTypes.string.isRequired,
};

export default Who;
